import { ADMIN_ROUTE, BASKET_ROUTE, CONTACTS_ROUTE, FORKLIT_ROUTE, DETAIL_ROUTE, DOCS_ROUTE, LOGIN_ROUTE, REGISTRATION_ROUTE, RENT_ROUTER, SERVICE_ROUTE, SHOP_ROUTE, VACANCIES_ROUTE, HOMEPAGE_ROUTE } from "./utils/consts";
import Admin from "./pages/Admin";
import Auth from "./pages/Auth";
import DetailPage from "./pages/DetailPage";
import Basket from "./pages/Basket";
import Shop from "./pages/Shop";
import Rent from "./pages/Rent"
import Contacts from "./pages/Contacts";
import Docs from "./pages/Docs";
import Vacancies from "./pages/Vacancies";
import Service from "./pages/Service";
import Forklit from "./pages/Forklit";
import HomePage from "./pages/Homepage";


export const authRoutes = [
    {
        path: ADMIN_ROUTE,
        Component: Admin
    },
]
export const publicRoutes = [
    {
        path: HOMEPAGE_ROUTE,
        Component: HomePage
    },
    {
        path: SHOP_ROUTE,
        Component: Shop
    },
    {
        path: LOGIN_ROUTE,
        Component: Auth
    },
    {
        path: REGISTRATION_ROUTE,
        Component: Auth
    },
    {
        path: DETAIL_ROUTE + '/:id',
        Component: DetailPage
    },
    {
        path: RENT_ROUTER,
        Component: Rent
    },
    {
        path: CONTACTS_ROUTE,
        Component: Contacts
    },
    {
        path: DOCS_ROUTE,
        Component: Docs
    },
    {
        path: VACANCIES_ROUTE,
        Component: Vacancies
    },
    {
        path: SERVICE_ROUTE,
        Component: Service
    },
    {
        path: BASKET_ROUTE,
        Component: Basket
    },
    {
        path: FORKLIT_ROUTE,
        Component: Forklit
    }
]